export default {
  targetReferences: [],
  status: {}
};